<template>
  <div>
    <common-banner :imgSrc="imgPath" :imgLabel="imgLabel" :path="'/opendata'"></common-banner>
    <el-row style="margin: 20px; padding: 0 6rem;">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }"><i class="el-icon-s-home"></i> 首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/dataset' }"><i class="el-icon-coin"></i> 数据集</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/dataset' }"><i class="el-icon-s-data"></i> {{ title }}</el-breadcrumb-item>
      </el-breadcrumb>
    </el-row>
    <home-main>
      <template slot="slot">
        <el-card class="box-card">
          <div slot="header">
            <strong><i class="el-icon-notebook-2"></i> {{ title }}</strong>
          </div>
          <el-form label-width="80px">
            <el-form-item v-for="record in records" :key="record.key">
              <template slot="label">
                <el-tag>{{ record.key }}</el-tag>
              </template>
              <span>{{ record.value }}</span>
            </el-form-item>
            <el-form-item>
              <template slot="label">
              <el-tag>平台链接</el-tag>
              </template>
              <span><a :href="link"> {{ link }}</a></span>
            </el-form-item>
            <el-form-item v-show="files && files.length>0">
              <template slot="label">
                <el-tag>格式</el-tag>
              </template>
              <el-tag v-for="tag in getEntryTags(files)" :key="tag" type="mini" :color="colors[tag]" effect="dark">{{tag}}</el-tag>

            </el-form-item>
            <!--el-form-item prop="download" label-width="80px">
              <template slot="label">
                <el-tag>下载</el-tag>
              </template>
              <div class="scroll-wrapper">
                <el-scrollbar class="scroll-list">
                  <ol class="li-wrapper">
                    <li v-for="item in files" :key="item">
                      <el-link type="primary" :underline="false" :href="link" target="_blank">{{item}}</el-link>
                      <el-tag v-for="tag in getTags(item)" :key="tag" type="mini" :color="colors[tag]" effect="dark">{{tag}}</el-tag>
                    </li>
                  </ol>
                </el-scrollbar>
              </div>
            </el-form-item-->
          </el-form>
          <el-form>
          </el-form>
        </el-card>
      </template>
    </home-main>
    <!--el-dialog title="下载" :visible.sync="dialog.visible" width="30%">
      <el-form label-width="100px">
        <el-form-item label="下载项">
          <el-link type="primary" :underline="false">{{ dialog.item }}</el-link>
        </el-form-item>
        <el-form-item label="验证码">
          <div v-loading="dialog.loading">
            <el-image :src="dialog.kaptcha" @click="refreshKaptchaUrl()" @load="imageLoaded"></el-image>
          </div>
        </el-form-item>
        <el-form-item label="填写验证码">
          <el-input v-model="dialog.code"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialog.visible = false">取 消</el-button>
        <el-button type="primary" :loading="dialog.loading" @click="downloadFile">下载</el-button>
      </span>
    </el-dialog-->
  </div>
</template>

<script>
import CommonBanner from '@/pages/common/Banner'
import HomeMain from '@/pages/homepage/components/Main'
import {getEntry, points} from '@/api/search'
import axios from 'axios'
import {Message} from 'element-ui'
import moment from 'moment'

export default {
  components: {
    CommonBanner,
    HomeMain
  },
  data () {
    return {
      imgPath: require('@/assets/images/banner/dataset_banner.jpg'),
      imgLabel: '开放数林',
      title: '',
      link: '',
      records: [],
      files: [],
      set: new Set(),
      tags: [],
      colors: {
        'json': '#dadf00',
        'xml': '#0b4442',
        'csv': '#006f6f',
        'xls': '#009844',
        'xlxs': '#49ab35',
        'pdf': '#76be69',
        'doc': '#0b4442',
        'docx': '#006f6f',
        'rdf': '#009844',
        'zip': '#49ab35',
        'rar': '#0b4442'
      },
      dialog: {
        visible: false,
        item: '',
        code: '',
        kaptcha: `${process.env.VUE_APP_DATA_URL}/kaptcha/render?${new Date().getTime()}`,
        loading: true
      }
    }
  },
  mounted () {
    points()
    getEntry(this.$route.query.entryid).then(response => {
      var entry = response.data
      this.title = entry.fileTitle
      this.link = entry.link
      let openType = entry.isFree === -1 ? '暂无' : entry.isFree === 1 ? '无条件开放' : '有条件开放'
      this.records.push(
        {
          key: '名称',
          value: entry.fileTitle
        },
        {
          key: '省份',
          value: entry.province
        },
        {
          key: '城市',
          value: entry.city
        },
        {
          key: '提供部门',
          value: entry.department
        },
        {
          key: '描述',
          value: entry.description === '' ? entry.fileTitle : entry.description
        },
        {
          key: '访问量',
          value: entry.viewCnt
        },
        {
          key: '采集时间',
          value: entry.year
        },
        {
          key: '开放条件',
          value: openType
        }
        // {
        //   key: '更新日期',
        //   value: moment(entry.mtime).format('YYYY-MM-DD HH:mm:ss')
        // }
      )
      this.files = JSON.parse(entry.dataSetFiles)
    })
  },
  methods: {
    getTags (fileName) {
      const set = new Set()
      const file = fileName.toLowerCase()
      if (file.includes('json')) {
        set.add('json')
      }
      if (file.includes('pdf')) {
        set.add('pdf')
      }
      if (file.includes('xml')) {
        set.add('xml')
      }
      if (file.includes('csv')) {
        set.add('csv')
      }
      if (file.includes('xlsx')) {
        set.add('xlsx')
      } else if (file.includes('xls')) {
        set.add('xls')
      }
      if (file.includes('docx')) {
        set.add('docx')
      } else if (file.includes('doc')) {
        set.add('doc')
      }
      if (file.includes('rdf')) {
        set.add('rdf')
      }
      if (file.includes('zip')) {
        set.add('zip')
      }
      if (file.includes('rar')) {
        set.add('rar')
      }
      return [...set]
    },
    getEntryTags () {
      let colors = new Set()
      if (this.files) {
        this.files.map(f => f.toLowerCase()).forEach((file) => {
          if (file.includes('json')) {
            colors.add('json')
          }
          if (file.includes('pdf')) {
            colors.add('pdf')
          } else if (file.includes('xml')) {
            colors.add('xml')
          } else if (file.includes('csv')) {
            colors.add('csv')
          } else if (file.includes('xlsx')) {
            colors.add('xlsx')
          } else if (file.includes('xls')) {
            colors.add('xls')
          } else if (file.includes('docx')) {
            colors.add('docx')
          } else if (file.includes('doc')) {
            colors.add('doc')
          } else if (file.includes('rdf')) {
            colors.add('rdf')
          } else if (file.includes('zip')) {
            colors.add('zip')
          } else if (file.includes('rar')) {
            colors.add('rar')
          }
        })
      }
      return [...colors]
    },
    getDownloadUrl (fileName, code) {
      return process.env.VUE_APP_DATA_URL + `/file/download?fileName=${fileName}&id=${this.$route.query.entryid}&code=${code}`
    },
    download (fileName) {
      this.dialog.visible = true
      this.dialog.item = fileName
      this.refreshKaptchaUrl()
    },
    downloadFile () {
      const fileName = this.dialog.item
      axios({
        method: 'get',
        url: `${process.env.VUE_APP_DATA_URL}/file/download?fileName=${fileName}&id=${this.$route.query.entryid}&code=${this.dialog.code}`,
        withCredentials: true
      }).then((res) => {
        let url = window.URL.createObjectURL(new Blob([res.data]))
        let link = document.createElement('a')
        link.style.display = 'none'
        link.href = url
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        this.dialog.visible = false
      }).catch(error => {
        Message({
          message: error.response.data,
          type: 'error',
          duration: 5 * 1000,
          customClass: 'zZindex'
        })
        return Promise.reject(error)
      })
    },
    refreshKaptchaUrl () {
      this.dialog.loading = true
      this.dialog.kaptcha = `${process.env.VUE_APP_DATA_URL}/file/kaptcha/render?${new Date().getTime()}`
    },
    imageLoaded () {
      this.dialog.loading = false
    }
  }
}
</script>

<style scoped>
.box-card {
  margin: 20px;
  width: 100%;
}

.box-card strong {
  font-size: 1.6rem;
  color: #2c3e50;
}

.li-wrapper {
  height: 150px;
  color: darkslategray;
  font-size: 10px;
}

.scroll-wrapper {
  max-height: 150px;
  max-width: 500px;
  border: 1px solid #ebebeb;
  border-radius: 3px;
}

.scroll-list {
  height: 220px;
}

.scroll-list .el-scrollbar__wrap {
  overflow-x: hidden;
}

.scroll-list .el-scrollbar__bar {
  opacity: unset;
}

.scroll-list .el-tag {
  margin-right: 5px;
  border-style: none;
}

.zZindex {
  z-index: 3000 !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/DetailPage.vue